import { render, staticRenderFns } from "./detalhes.vue?vue&type=template&id=70fdaf9d&"
import script from "./detalhes.vue?vue&type=script&lang=js&"
export * from "./detalhes.vue?vue&type=script&lang=js&"
import style0 from "./detalhes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports